import Vue from 'vue'

//Vue Material Components
import { 
  MdApp, MdDrawer, MdToolbar, 
  MdIcon, MdList, MdContent, 
  MdField, MdButton, MdSteppers, 
  MdTabs, MdSnackbar, MdCard, 
  MdTooltip, MdCheckbox, MdRadio,
  MdDialog, MdRipple, MdTable,
  MdMenu, MdSwitch, MdEmptyState,
  MdProgress, MdSpeedDial, MdBadge
} from 'vue-material/dist/components'

Vue.use(MdApp); Vue.use(MdDrawer); Vue.use(MdToolbar);
Vue.use(MdIcon); Vue.use(MdList); Vue.use(MdContent);
Vue.use(MdField); Vue.use(MdButton); Vue.use(MdSteppers);
Vue.use(MdTabs); Vue.use(MdSnackbar); Vue.use(MdCard);
Vue.use(MdTooltip); Vue.use(MdCheckbox); Vue.use(MdRadio);
Vue.use(MdDialog); Vue.use(MdRipple); Vue.use(MdTable);
Vue.use(MdMenu); Vue.use(MdSwitch); Vue.use(MdEmptyState);
Vue.use(MdProgress); Vue.use(MdSpeedDial); Vue.use(MdBadge);

//Rich Text Editor Component
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor, {modules: {clipboard: {matchVisual: false}}});

import headful from 'vue-headful'
Vue.component('headful', headful);